import { render } from "./AcceuilPage.vue?vue&type=template&id=33bff3ad"
import script from "./AcceuilPage.vue?vue&type=script&lang=js"
export * from "./AcceuilPage.vue?vue&type=script&lang=js"

import "./AcceuilPage.vue?vue&type=style&index=0&id=33bff3ad&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__